import React, { useRef } from "react";
import { ProgressStepForm, FormStep } from "./ProgressStepForm";
import { getFormInput } from "./utils";
import Column from "@amzn/meridian/column";
import { addSpaceValidationSchema, createPropertyConfig } from "./definitions";
import { useSheets } from "../../features/sheets/hooks";

export const AddSpaceForm = ({ initialValues, onSubmitHandler }) => {
    const addSpaceFormRef = useRef(null);

    const { addSpace } = createPropertyConfig;
    const { setOpenSheets } = useSheets();

    return (
        <Column width={"100%"}>
            <Column width={"fill"}>
                <ProgressStepForm
                    onSubmit={values => {
                        onSubmitHandler(values);
                        setOpenSheets(false);
                    }}
                    formName={"addSpace"}
                    initialValues={initialValues}
                    formRef={addSpaceFormRef}
                >
                    <FormStep
                        onSubmit={() => console.log("submitting first step")}
                        validationSchema={addSpaceValidationSchema}
                    >
                        {getFormInput({ addSpace })}
                    </FormStep>
                </ProgressStepForm>
            </Column>
        </Column>
    );
};
